<template>
  <ul>
    <li v-for="(item, index) in list" @click="jump(item)" :key="index">
      <div class="list">
        <img :src="item.coverPicUrl" alt="" />
        <div>
          <h5>{{ item.courseName }}</h5>
          <p>
            <span style="margin-right: .2rem">{{ item.userName }}</span>
            <span>{{ item.duties }}</span>
          </p>
          <p>{{ item.hospitalName }}</p>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: '',
  props: {
    list: {
      type: Array,
      default: function() {
        return [
          //            {
          //              "id": "9d7e429e-055a-4dc0-ad0a-aa1ddf92935d",
          //              "title": "0808-8",
          //              "coverPic": "http://yxvzb.b0.upaiyun.com//images/1502164261767.jpg",
          //              "userName": "李天",
          //              "userDuty": "副主任医师",
          //              "userCompanyName": "广州医科大学附属第五医院"
          //            }
        ];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    jump(item) {
      let wxUserInfoObj = this.$api.getStorage('wxUserInfo');

      this.$router.push({ name: 'courseDetail', params: { id: item.id } });
    }
  },
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.hidenText() {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    margin-bottom: 0.8rem;
    .list {
      img {
        display: block;
        width: 4.533rem;
        height: 2.56rem;
        border-radius: 0.1rem;
        margin-bottom: 0.1rem;
      }
      h5 {
        font-size: 0.3733rem;
        width: 4.533rem;
        .hidenText();
      }
      p {
        font-size: 0.32rem;
        color: #999;
        line-height: 1.3;
        width: 4.533rem;
        .hidenText();
      }
    }
    .big {
      width: 100%;

      * {
        font-size: 0.3733rem;
      }
      img {
        width: 9.2rem;
        height: 4.4rem;
      }
      .bd {
        display: flex;
        justify-content: space-between;

        .bs1 {
        }
        .bs2 {
          color: #999;
        }
      }
    }
  }
}
</style>
